import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import {dataService} from '../../services/data.services'

const initialState = {
    loading: true,
    status:'',
    List:[]
}
// export const AdminCorporate = createAsyncThunk('AdminCorporate', async (searchParams) => {
//     let res = await dataService.GetAPI(searchParams);
//     //let res = await dataService.GetAPI(searchParams.toString());
//     return res
// })
const AdminCorporateSlice = createSlice({

    name: 'AdminCorporate-list',
    initialState,
    reducers: {
        setLoader: (state, action) => {
            if(action.payload.length>1){
                state.loading = action.payload[0],
                state.status = action.payload[1]
            }
            else{
                state.loading=action.payload
            }
            
        },
        setList:(state,action)=>{
            state.List=action.payload
        }

    },
   
})
export const { setLoader ,setList} = AdminCorporateSlice.actions;
export default AdminCorporateSlice.reducer